const en = {
  common: {
    loading: "Loading...",
    search: "Search",
    next: "Next",
    back: "Back",
    cancel: "Cancel",
    until: "Until",
    data: "Data",
    edit: "Edit",
    chat: "Chat",
    language: "Language",
    interests: "Interests",
  },
  Home: {
    welcome: "Welcome home!",
  },
  forms: {
    name: "Name",
    firstName: "First name",
    lastName: "Last name",
    username: "Username",
    email: "Email",
    confirmEmail: "Confirm email",
    password: "Password",
    confirmPassword: "Confirm password",
    login: "Login",
    loginTitle: "Log in",
    register: "Register",
    registerTitle: "Register",
    registerDescription: "Enter your name, email and password",
    chooseLanguages: "Choose the languages you speak",
    chooseInterests: "Choose your interests",
    chooseSkills: "Add your skills",
    addSkill: "Skill",
    signout: "Sign Out",
    save: "Save",
    done: "Done",
    cancel: "Cancel",
    or: "Or",
    completeRegistration: "Complete Registration",
  },
  nav: {
    profile: "My Account",
    projects: "Projects",
    feed: "Feed",
    explore: "Find project",
    myAccount: "My Account",
    jobs: "Jobs",
  },
  profile: {
    profile: "Profile",
    name: "Name",
    username: "Username",
    credentials: "Credentials",
    email: "Email",
    location: "Location",
    bio: "Bio",
    skills: "Skills",
    languages: "Languages",
    interests: "Interests",
    following: "Following",
    followers: "Followers",
    editProfile: "Edit profile",
  },
  steps: {
    next: "Next",
    back: "Back",
    name: "Name",
    description: "Description",
    data: "Data",
    language: "Language",
    interests: "Interests",
    skills: "Skills",
    photo: "Photo",
    category: "Category",
    timePeriod: "Time period",
    members: "Members",
  },
  project: {
    requestedProjects: "Requested projects",
    joinedProjects: "Joined projects",
    createdProjects: "Created projects",
    members: "Members",
    owner: "Owner",
    roles: "Roles",
    applications: "Applications",
    requirements: "Requirements",
    createProject: "Create project",
    projectInformation: "Project information",
    name: "Name",
    description: "Description",
    roleName: "Role name",
    projectName: "Project name",
    skill: "Skill",
    skills: "Skills",

    addName: "Choose a name for your project",
    addPhoto: "Choose a picture for your project (optional)",
    addDescription: "Add a description",
    addLanguages: "Add the spoken language (max 2)",
    addCategories: "Add categories (max 3)",
    addTimePeriod: "Choose the time period (optional)",
    addRoles: "Add roles to your project (optional)",
    title: "Title",
    addTitle: "Enter a role title",
    createRole: "Create role",
    addSkill: "Enter a skill",
    addRole: "Add this role",

    openVacancies: "Open vacancies",
    roleDescription: "Role description",
    roleRequirements: "Requirements",
    apply: "Apply",

    exitProject: "Leave this project",
    deleteProject: "Delete this project",
    deleteProjectWarning:
      "Are you sure you want to delete this project. This step cannot be undone.",

    status: {
      root: "Status",
      inProgress: "In progress",
      idle: "Idle",
      done: "Done",
    },
  },
  interests: {
    cryptocurrency: "Cryptocurrency",
    business: "Business",
    psychology: "Psychology",
    philosophy: "Philosophy",
    work: "Work",
    money: "Money",
    future: "Future",
    technology: "Technology",
    travel: "Travel",
    programming: "Programming",
    electro: "Electro",
    startup: "Startup",
    cybersecurity: "Cybersecurity",
    writing: "Writing",
    life: "Life",
    literature: "Literature",
    art: "Art",
    design: "Design",
    photography: "Photography",
    culture: "Culture",
    music: "Music",
    dancing: "Dancing",
  },
  application: {
    viewApplication: "View application",
  },
  chat: {
    writeMessage: "Write a message...",
  },
  launchScreen: {
    sectionOne: {
      heading: "Let's work together!",
      text: "With WeCollab you have the possibility to create a project and add existing team members as well as search for new team members.",
    },
    sectionTwo: {
      heading: "Create projects",
      text: "You have the possibility to create projects and add existing members or create a new project and find new team members.",
    },
    sectionThree: {
      heading: "Find projects",
      text: "Are you looking for a new challenge? Then WeCollab is the right choice! You have the opportunity to join projects with your interests and your skills.",
    },
    sectionFour: {
      heading: "Make new contacts",
      text: "Through WeCollab you have the opportunity to find new contacts that will help you in the future. You can build a network that you can access at any time.",
    },
  },
};

export default en;
